import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';

const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'PROCESSING', label: 'Processing' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'CANCELLED', label: 'Cancelled' },
];

export const FilterFormComponent = () => {
    return (
        <Field
            name="status"
            label="Status"
            data={statusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
